

// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import {
//   fetchBusinesses,
//   createBusiness,
//   updateBusiness,
//   deleteBusiness,
//   fetchBusinessById,
//   uploadBusinessTheme,
//   uploadBusinessAsset,
//   uploadDashboardTheme,
//   getSelectedBusinessDashboardTheme, // 👈 Import the new action
// } from "../actions/businessActions";
// import { ThemeName } from "./themeSlice";
// import { themes } from "../../assets/themes";

// /** ------------------- TYPES ------------------- **/

// export interface AdminUser {
//   id: string;
//   uid: string;
//   email: string;
//   roles: string[];
//   temporaryPassword?: string;
//   created_at: string | null;
//   updated_at: string | null;
// }

// export enum BusinessStatus {
//   ACTIVE = "active",
//   INACTIVE = "inactive"
// }

// export interface Business {
//   id: string;
//   code: string;
//   name: string;
//   display_name?: string;
//   type: string;
//   enable_advisors: boolean;
//   need_client_id: boolean;
//   need_admin_dashboard: boolean;
//   theme_uploaded: boolean;
//   theme_json?: any;
//   status: BusinessStatus;
//   created_at: string | null;
//   updated_at: string | null;
//   theme_uploaded_at?: string | null;
//   admins?: AdminUser[];
//   // Asset upload flags
//   logo_uploaded?: boolean;
//   logo_url?: string;
//   logo_uploaded_at?: string | null;
//   logo_filename?: string;
  
//   background_uploaded?: boolean;
//   background_url?: string;
//   background_uploaded_at?: string | null;
//   background_filename?: string;
  
//   theme_url?: string;
//   theme_filename?: string;
//   theme_version?: number; // 👈 Add theme version
//   theme_doc_id?: string; // 👈 Reference to businessTheme document
// }

// interface BusinessState {
//   businesses: Business[];
//   selectedBusiness: Business | null;
//   selectedBusinessTheme: typeof themes[ThemeName] | null;
//   currentBusiness: Business | null;
//   loading: boolean;
//   error: string | null;
//   // Pagination
//   page: number;
//   limit: number;
//   total: number;
//   lastDocId: string | null;
//   // Create operation
//   creating: boolean;
//   createError: string | null;
//   createSuccess: boolean;
//   // Update operation
//   updating: boolean;
//   updateError: string | null;
//   updateSuccess: boolean;
//   // Delete operation
//   deleting: boolean;
//   deleteError: string | null;
//   deleteSuccess: boolean;
//   // Upload theme operation (legacy)
//   uploading: boolean;
//   uploadError: string | null;
//   uploadSuccess: boolean;
//   // Upload dashboard theme operation (new)
//   dashboardThemeUploading: boolean;
//   dashboardThemeUploadError: string | null;
//   dashboardThemeUploadSuccess: boolean;
//   dashboardThemeVersion: number | null;
//   // Upload business asset operation
//   assetUploading: boolean;
//   assetUploadError: string | null;
//   assetUploadSuccess: boolean;

     
//   // ============== LOADING & ERROR STATES ==============
//   selectedBusinessThemeLoading: boolean;
//   selectedBusinessThemeError: string | null;
//   selectedBusinessThemeSuccess: boolean;
// }

// const initialState: BusinessState = {
//   businesses: [],
//   selectedBusiness: null,
//   selectedBusinessTheme: null,
//   currentBusiness: null,
//   loading: false,
//   error: null,
//   // Pagination
//   page: 1,
//   limit: 10,
//   total: 0,
//   lastDocId: null,
//   // Create operation
//   creating: false,
//   createError: null,
//   createSuccess: false,
//   // Update operation
//   updating: false,
//   updateError: null,
//   updateSuccess: false,
//   // Delete operation
//   deleting: false,
//   deleteError: null,
//   deleteSuccess: false,
//   // Upload theme operation (legacy)
//   uploading: false,
//   uploadError: null,
//   uploadSuccess: false,
//   // Upload dashboard theme operation (new)
//   dashboardThemeUploading: false,
//   dashboardThemeUploadError: null,
//   dashboardThemeUploadSuccess: false,
//   dashboardThemeVersion: null,
//   // Upload business asset operation
//   assetUploading: false,
//   assetUploadError: null,
//   assetUploadSuccess: false,

//   selectedBusinessThemeLoading: false,
//   selectedBusinessThemeError:  null,
//   selectedBusinessThemeSuccess: false,
// };

// /** ------------------- SLICE ------------------- **/

// const businessSlice = createSlice({
//   name: "businesses",
//   initialState,
//   reducers: {
//     // Clear errors
//     clearErrors: (state) => {
//       state.error = null;
//       state.createError = null;
//       state.updateError = null;
//       state.deleteError = null;
//       state.uploadError = null;
//       state.dashboardThemeUploadError = null; // 👈 Add
//       state.assetUploadError = null;
//     },
//     // Clear success flags
//     clearSuccessFlags: (state) => {
//       state.createSuccess = false;
//       state.updateSuccess = false;
//       state.deleteSuccess = false;
//       state.uploadSuccess = false;
//       state.dashboardThemeUploadSuccess = false; // 👈 Add
//       state.assetUploadSuccess = false;
//     },
//     clearUploadFlags: (state) => {
//       state.uploadSuccess = false;
//       state.uploadError = null;
//     },
//     clearDashboardThemeUploadFlags: (state) => { // 👈 New reducer
//       state.dashboardThemeUploadSuccess = false;
//       state.dashboardThemeUploadError = null;
//     },
//     // Set selected business
//     setSelectedBusiness: (state, action: PayloadAction<Business | null>) => {
//       state.selectedBusiness = action.payload;
//     },
//     // Set current business (for details page)
//     setCurrentBusiness: (state, action: PayloadAction<Business | null>) => {
//       state.currentBusiness = action.payload;
//     },
//     // Clear current business
//     clearCurrentBusiness: (state) => {
//       state.currentBusiness = null;
//     },
//     // Reset state
//     resetBusinessState: () => initialState,
//     // Set page
//     setPage: (state, action: PayloadAction<number>) => {
//       state.page = action.payload;
//     },
//     // Set limit
//     setLimit: (state, action: PayloadAction<number>) => {
//       state.limit = action.payload;
//     },
//     resetAssetUploadState: (state) => {
//       state.assetUploading = false;
//       state.assetUploadSuccess = false;
//       state.assetUploadError = null;
//     },
//     // Update business theme info from dashboard theme upload
//     updateBusinessThemeInfo: (state, action: PayloadAction<{
//       businessId: string;
//       themeVersion: number;
//       themeDocId: string;
//       logoUrl?: string | null;
//     }>) => {
//       const { businessId, themeVersion, themeDocId, logoUrl } = action.payload;
      
//       // Update in businesses list
//       const businessIndex = state.businesses.findIndex(b => b.id === businessId);
//       if (businessIndex !== -1) {
//         state.businesses[businessIndex].theme_uploaded = true;
//         state.businesses[businessIndex].theme_version = themeVersion;
//         state.businesses[businessIndex].theme_doc_id = themeDocId;
//         state.businesses[businessIndex].theme_uploaded_at = new Date().toISOString();
//         if (logoUrl) {
//           state.businesses[businessIndex].logo_uploaded = true;
//           state.businesses[businessIndex].logo_url = logoUrl;
//           state.businesses[businessIndex].logo_uploaded_at = new Date().toISOString();
//         }
//       }
      
//       // Update current business if it matches
//       if (state.currentBusiness?.id === businessId) {
//         state.currentBusiness.theme_uploaded = true;
//         state.currentBusiness.theme_version = themeVersion;
//         state.currentBusiness.theme_doc_id = themeDocId;
//         state.currentBusiness.theme_uploaded_at = new Date().toISOString();
//         if (logoUrl) {
//           state.currentBusiness.logo_uploaded = true;
//           state.currentBusiness.logo_url = logoUrl;
//           state.currentBusiness.logo_uploaded_at = new Date().toISOString();
//         }
//       }
      
//       // Update selected business if it matches
//       if (state.selectedBusiness?.id === businessId) {
//         state.selectedBusiness.theme_uploaded = true;
//         state.selectedBusiness.theme_version = themeVersion;
//         state.selectedBusiness.theme_doc_id = themeDocId;
//         state.selectedBusiness.theme_uploaded_at = new Date().toISOString();
//         if (logoUrl) {
//           state.selectedBusiness.logo_uploaded = true;
//           state.selectedBusiness.logo_url = logoUrl;
//           state.selectedBusiness.logo_uploaded_at = new Date().toISOString();
//         }
//       }
      
//       state.dashboardThemeVersion = themeVersion;
//     },
//   },
//   extraReducers: (builder) => {
//     /** -------- FETCH BUSINESSES -------- **/
//     builder
//     // ============= FETCH SELECTED BUSINESS DASHBOARD THEME ==============
//     .addCase(getSelectedBusinessDashboardTheme.pending, (state) => {
//       state.selectedBusinessThemeLoading = true;
//       state.selectedBusinessThemeError = null;
//       state.selectedBusinessThemeSuccess = false;
//       console.log(`⏳ Fetching dashboard theme for business...`, state.selectedBusiness?.id);
//     })
//     .addCase(getSelectedBusinessDashboardTheme.fulfilled, (state, action) => {
//       state.selectedBusinessThemeLoading = false;
//       state.selectedBusinessThemeSuccess = true;
//       state.selectedBusinessThemeError = null;

//       const themeData = action.payload.data;
//       if(themeData && themeData.theme) {
//         state.selectedBusinessTheme = themeData.theme || null;
//       }
//     })
//     .addCase(getSelectedBusinessDashboardTheme.rejected, (state, action) => {
//       state.selectedBusinessThemeLoading = false;
//       state.selectedBusinessThemeSuccess = false;
//       state.selectedBusinessThemeError = action.payload as string || 'Failed to fetch dashboard theme';
      
//       // If theme not found, clear business theme
//       if (action.payload === "THEME_NOT_FOUND") {
//         console.log(`⚠️ Theme not found, clearing business theme`);
//         state.selectedBusinessTheme = null;
//       }
      
//       console.error(`❌ Failed to fetch dashboard theme:`, action.payload);
//     })
//     // ============== FETCH BUSINESSES ==============
//       .addCase(fetchBusinesses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchBusinesses.fulfilled, (state, action) => {
//         state.loading = false;
//         state.businesses = action.payload.data;
//         state.page = action.payload.page;
//         state.limit = action.payload.limit;
//         state.total = action.payload.total;
//         state.lastDocId = action.payload.lastDocId;
//       })
//       .addCase(fetchBusinesses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || "Failed to fetch businesses";
//       });

//     /** -------- FETCH BUSINESS BY ID -------- **/
//     builder
//       .addCase(fetchBusinessById.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchBusinessById.fulfilled, (state, action) => {
//         state.loading = false;
//        // state.selectedBusiness = action.payload;
//         state.currentBusiness = action.payload;
//       })
//       .addCase(fetchBusinessById.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || "Failed to fetch business";
//         state.currentBusiness = null;
//       });

//     /** -------- CREATE BUSINESS -------- **/
//     builder
//       .addCase(createBusiness.pending, (state) => {
//         state.creating = true;
//         state.createError = null;
//         state.createSuccess = false;
//       })
//       .addCase(createBusiness.fulfilled, (state, action) => {
//         state.creating = false;
//         state.createSuccess = true;
//         state.businesses.unshift(action.payload);
//         state.total += 1;
//       })
//       .addCase(createBusiness.rejected, (state, action) => {
//         state.creating = false;
//         state.createError = action.payload || "Failed to create business";
//         state.createSuccess = false;
//       });

//     /** -------- UPDATE BUSINESS -------- **/
//     builder
//       .addCase(updateBusiness.pending, (state) => {
//         state.updating = true;
//         state.updateError = null;
//         state.updateSuccess = false;
//       })
//       .addCase(updateBusiness.fulfilled, (state, action) => {
//         state.updating = false;
//         state.updateSuccess = true;
        
//         const index = state.businesses.findIndex(
//           (b) => b.id === action.payload.id
//         );
//         if (index !== -1) {
//           state.businesses[index] = action.payload;
//         }
        
//         if (state.selectedBusiness?.id === action.payload.id) {
//           state.selectedBusiness = action.payload;
//         }
        
//         if (state.currentBusiness?.id === action.payload.id) {
//           state.currentBusiness = action.payload;
//         }
//       })
//       .addCase(updateBusiness.rejected, (state, action) => {
//         state.updating = false;
//         state.updateError = action.payload || "Failed to update business";
//         state.updateSuccess = false;
//       });

//     /** -------- DELETE BUSINESS -------- **/
//     builder
//       .addCase(deleteBusiness.pending, (state) => {
//         state.deleting = true;
//         state.deleteError = null;
//         state.deleteSuccess = false;
//       })
//       .addCase(deleteBusiness.fulfilled, (state, action) => {
//         state.deleting = false;
//         state.deleteSuccess = true;
//         state.businesses = state.businesses.filter(
//           (b) => b.id !== action.payload
//         );
//         state.total -= 1;
        
//         if (state.selectedBusiness?.id === action.payload) {
//           state.selectedBusiness = null;
//         }
//         if (state.currentBusiness?.id === action.payload) {
//           state.currentBusiness = null;
//         }
//       })
//       .addCase(deleteBusiness.rejected, (state, action) => {
//         state.deleting = false;
//         state.deleteError = action.payload || "Failed to delete business";
//         state.deleteSuccess = false;
//       });

//     /** -------- UPLOAD BUSINESS THEME (Legacy) -------- **/
//     builder
//       .addCase(uploadBusinessTheme.pending, (state) => {
//         state.uploading = true;
//         state.uploadError = null;
//         state.uploadSuccess = false;
//       })
//       .addCase(uploadBusinessTheme.fulfilled, (state, action) => {
//         state.uploading = false;
//         state.uploadSuccess = true;
        
//         const businessCode = action.payload.businessData?.code;
        
//         const businessIndex = state.businesses.findIndex(b => b.code === businessCode);
//         if (businessIndex !== -1) {
//           state.businesses[businessIndex].theme_uploaded = true;
//           state.businesses[businessIndex].theme_uploaded_at = action.payload.businessData?.theme_uploaded_at;
//         }
        
//         if (state.selectedBusiness && state.selectedBusiness?.code === businessCode) {
//           state.selectedBusiness.theme_uploaded = true;
//           state.selectedBusiness.theme_uploaded_at = action.payload.businessData?.theme_uploaded_at;
//         }
        
//         if (state.currentBusiness && state.currentBusiness?.code === businessCode) {
//           state.currentBusiness.theme_uploaded = true;
//           state.currentBusiness.theme_uploaded_at = action.payload.businessData?.theme_uploaded_at;
//         }
//       })
//       .addCase(uploadBusinessTheme.rejected, (state, action) => {
//         state.uploading = false;
//         state.uploadError = action.payload || "Failed to upload theme";
//         state.uploadSuccess = false;
//       })

//     /** -------- UPLOAD DASHBOARD THEME (New) -------- **/
//     builder
//       .addCase(uploadDashboardTheme.pending, (state) => {
//         state.dashboardThemeUploading = true;
//         state.dashboardThemeUploadError = null;
//         state.dashboardThemeUploadSuccess = false;
//       })
//       .addCase(uploadDashboardTheme.fulfilled, (state, action) => {
//         state.dashboardThemeUploading = false;
//         state.dashboardThemeUploadSuccess = true;
        
//         const { businessId, themeVersion, themeDocId, logoUrl, businessName } = action.payload.data;
        
//         // Update business theme info
//         state.dashboardThemeVersion = themeVersion;
        
//         // Find and update business in list
//         const businessIndex = state.businesses.findIndex(b => b.id === businessId);
//         if (businessIndex !== -1) {
//           state.businesses[businessIndex].theme_uploaded = true;
//           state.businesses[businessIndex].theme_version = themeVersion;
//           state.businesses[businessIndex].theme_doc_id = themeDocId;
//           state.businesses[businessIndex].theme_uploaded_at = new Date().toISOString();
          
//           if (logoUrl) {
//             state.businesses[businessIndex].logo_uploaded = true;
//             state.businesses[businessIndex].logo_url = logoUrl;
//             state.businesses[businessIndex].logo_uploaded_at = new Date().toISOString();
//           }
//         }
        
//         // Update current business if it matches
//         if (state.currentBusiness?.id === businessId) {
//           state.currentBusiness.theme_uploaded = true;
//           state.currentBusiness.theme_version = themeVersion;
//           state.currentBusiness.theme_doc_id = themeDocId;
//           state.currentBusiness.theme_uploaded_at = new Date().toISOString();
          
//           if (logoUrl) {
//             state.currentBusiness.logo_uploaded = true;
//             state.currentBusiness.logo_url = logoUrl;
//             state.currentBusiness.logo_uploaded_at = new Date().toISOString();
//           }
//         }
        
//         // Update selected business if it matches
//         if (state.selectedBusiness?.id === businessId) {
//           state.selectedBusiness.theme_uploaded = true;
//           state.selectedBusiness.theme_version = themeVersion;
//           state.selectedBusiness.theme_doc_id = themeDocId;
//           state.selectedBusiness.theme_uploaded_at = new Date().toISOString();
          
//           if (logoUrl) {
//             state.selectedBusiness.logo_uploaded = true;
//             state.selectedBusiness.logo_url = logoUrl;
//             state.selectedBusiness.logo_uploaded_at = new Date().toISOString();
//           }
//         }
        
//         console.log(`✅ Dashboard theme v${themeVersion} uploaded for business ${businessId}`);
//       })
//       .addCase(uploadDashboardTheme.rejected, (state, action) => {
//         state.dashboardThemeUploading = false;
//         state.dashboardThemeUploadError = action.payload || "Failed to upload dashboard theme";
//         state.dashboardThemeUploadSuccess = false;
//       })

//     /** -------- UPLOAD BUSINESS ASSET (Logo, Background) -------- **/
//     builder
//       .addCase(uploadBusinessAsset.pending, (state) => {
//         state.assetUploading = true;
//         state.assetUploadError = null;
//         state.assetUploadSuccess = false;
//       })
//       .addCase(uploadBusinessAsset.fulfilled, (state, action) => {
//         state.assetUploading = false;
//         state.assetUploadSuccess = true;
        
//         const { fileType, publicUrl, timestamp } = action.payload;
//         const fileName = action.meta.arg.fileName;
        
//         if (state.currentBusiness) {
//           switch (fileType) {
//             case 'logo':
//               state.currentBusiness.logo_uploaded = true;
//               state.currentBusiness.logo_url = publicUrl;
//               state.currentBusiness.logo_uploaded_at = timestamp;
//               state.currentBusiness.logo_filename = fileName;
//               break;
              
//             case 'background':
//               state.currentBusiness.background_uploaded = true;
//               state.currentBusiness.background_url = publicUrl;
//               state.currentBusiness.background_uploaded_at = timestamp;
//               state.currentBusiness.background_filename = fileName;
//               break;
              
//             case 'theme':
//               state.currentBusiness.theme_uploaded = true;
//               state.currentBusiness.theme_url = publicUrl;
//               state.currentBusiness.theme_uploaded_at = timestamp;
//               state.currentBusiness.theme_filename = fileName;
//               break;
//           }
//         }
        
//         if (state.currentBusiness?.id) {
//           const index = state.businesses.findIndex(b => b.id === state.currentBusiness?.id);
//           if (index !== -1) {
//             switch (fileType) {
//               case 'logo':
//                 state.businesses[index].logo_uploaded = true;
//                 state.businesses[index].logo_url = publicUrl;
//                 state.businesses[index].logo_uploaded_at = timestamp;
//                 state.businesses[index].logo_filename = fileName;
//                 break;
//               case 'background':
//                 state.businesses[index].background_uploaded = true;
//                 state.businesses[index].background_url = publicUrl;
//                 state.businesses[index].background_uploaded_at = timestamp;
//                 state.businesses[index].background_filename = fileName;
//                 break;
//               case 'theme':
//                 state.businesses[index].theme_uploaded = true;
//                 state.businesses[index].theme_url = publicUrl;
//                 state.businesses[index].theme_uploaded_at = timestamp;
//                 state.businesses[index].theme_filename = fileName;
//                 break;
//             }
//           }
//         }
//       })
//       .addCase(uploadBusinessAsset.rejected, (state, action) => {
//         state.assetUploading = false;
//         state.assetUploadSuccess = false;
//         state.assetUploadError = action.payload as string;
//       });
//   },
// });

// /** ------------------- EXPORTS ------------------- **/

// export const {
//   clearErrors,
//   clearSuccessFlags,
//   setSelectedBusiness,
//   setCurrentBusiness,
//   clearCurrentBusiness,
//   resetBusinessState,
//   setPage,
//   setLimit,
//   clearUploadFlags,
//   clearDashboardThemeUploadFlags, // 👈 Export new reducer
//   updateBusinessThemeInfo, // 👈 Export new reducer
//   resetAssetUploadState,
// } = businessSlice.actions;

// export default businessSlice.reducer;












import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchBusinesses,
  createBusiness,
  updateBusiness,
  deleteBusiness,
  fetchBusinessById,
  uploadBusinessTheme,
  uploadBusinessAsset,
  uploadDashboardTheme,
  uploadAppBusinessAsset, // 👈 Import the new action
  getSelectedBusinessDashboardTheme,
} from "../actions/businessActions";
import { ThemeName } from "./themeSlice";
import { themes } from "../../assets/themes";

/** ------------------- TYPES ------------------- **/

export interface AdminUser {
  id: string;
  uid: string;
  email: string;
  roles: string[];
  temporaryPassword?: string;
  created_at: string | null;
  updated_at: string | null;
}

export enum BusinessStatus {
  ACTIVE = "active",
  INACTIVE = "inactive"
}

export interface Business {
  id: string;
  code: string;
  name: string;
  display_name?: string;
  type: string;
  enable_advisors: boolean;
  need_client_id: boolean;
  need_admin_dashboard: boolean;
  theme_uploaded: boolean;
  theme_json?: any;
  status: BusinessStatus;
  created_at: string | null;
  updated_at: string | null;
  theme_uploaded_at?: string | null;
  admins?: AdminUser[];
  // Asset upload flags
  logo_uploaded?: boolean;
  logo_url?: string;
  logo_uploaded_at?: string | null;
  logo_filename?: string;
  
  background_uploaded?: boolean;
  background_url?: string;
  background_uploaded_at?: string | null;
  background_filename?: string;
  
  theme_url?: string;
  theme_filename?: string;
  theme_version?: number;
  theme_doc_id?: string;
  
  // ============== APP ASSETS ==============
  // App Logos
  app_logo_light_uploaded?: boolean;
  app_logo_light_url?: string;
  app_logo_light_uploaded_at?: string | null;
  app_logo_light_filename?: string;
  
  app_logo_dark_uploaded?: boolean;
  app_logo_dark_url?: string;
  app_logo_dark_uploaded_at?: string | null;
  app_logo_dark_filename?: string;
  
  // App Backgrounds
  app_background_light_uploaded?: boolean;
  app_background_light_url?: string;
  app_background_light_uploaded_at?: string | null;
  app_background_light_filename?: string;
  
  app_background_dark_uploaded?: boolean;
  app_background_dark_url?: string;
  app_background_dark_uploaded_at?: string | null;
  app_background_dark_filename?: string;
  
  // Onboarding Images
  onboarding_images?: Array<{
    id: number;
    url: string;
    filename: string;
    uploaded_at: string | null;
  }>;
  onboarding_count?: number;
}

interface BusinessState {
  businesses: Business[];
  selectedBusiness: Business | null;
  selectedBusinessTheme: typeof themes[ThemeName] | null;
  currentBusiness: Business | null;
  loading: boolean;
  error: string | null;
  // Pagination
  page: number;
  limit: number;
  total: number;
  lastDocId: string | null;
  // Create operation
  creating: boolean;
  createError: string | null;
  createSuccess: boolean;
  // Update operation
  updating: boolean;
  updateError: string | null;
  updateSuccess: boolean;
  // Delete operation
  deleting: boolean;
  deleteError: string | null;
  deleteSuccess: boolean;
  // Upload theme operation (legacy)
  uploading: boolean;
  uploadError: string | null;
  uploadSuccess: boolean;
  // Upload dashboard theme operation (new)
  dashboardThemeUploading: boolean;
  dashboardThemeUploadError: string | null;
  dashboardThemeUploadSuccess: boolean;
  dashboardThemeVersion: number | null;
  // Upload business asset operation
  assetUploading: boolean;
  assetUploadError: string | null;
  assetUploadSuccess: boolean;
  
  // ============== APP ASSETS UPLOAD STATES ==============
  appAssetUploading: boolean;
  appAssetUploadError: string | null;
  appAssetUploadSuccess: boolean;
  
  // ============== LOADING & ERROR STATES ==============
  selectedBusinessThemeLoading: boolean;
  selectedBusinessThemeError: string | null;
  selectedBusinessThemeSuccess: boolean;
}

const initialState: BusinessState = {
  businesses: [],
  selectedBusiness: null,
  selectedBusinessTheme: null,
  currentBusiness: null,
  loading: false,
  error: null,
  // Pagination
  page: 1,
  limit: 10,
  total: 0,
  lastDocId: null,
  // Create operation
  creating: false,
  createError: null,
  createSuccess: false,
  // Update operation
  updating: false,
  updateError: null,
  updateSuccess: false,
  // Delete operation
  deleting: false,
  deleteError: null,
  deleteSuccess: false,
  // Upload theme operation (legacy)
  uploading: false,
  uploadError: null,
  uploadSuccess: false,
  // Upload dashboard theme operation (new)
  dashboardThemeUploading: false,
  dashboardThemeUploadError: null,
  dashboardThemeUploadSuccess: false,
  dashboardThemeVersion: null,
  // Upload business asset operation
  assetUploading: false,
  assetUploadError: null,
  assetUploadSuccess: false,
  
  // ============== APP ASSETS UPLOAD STATES ==============
  appAssetUploading: false,
  appAssetUploadError: null,
  appAssetUploadSuccess: false,
  
  selectedBusinessThemeLoading: false,
  selectedBusinessThemeError:  null,
  selectedBusinessThemeSuccess: false,
};

/** ------------------- SLICE ------------------- **/

const businessSlice = createSlice({
  name: "businesses",
  initialState,
  reducers: {
    // Clear errors
    clearErrors: (state) => {
      state.error = null;
      state.createError = null;
      state.updateError = null;
      state.deleteError = null;
      state.uploadError = null;
      state.dashboardThemeUploadError = null;
      state.assetUploadError = null;
      state.appAssetUploadError = null; // 👈 Add
    },
    // Clear success flags
    clearSuccessFlags: (state) => {
      state.createSuccess = false;
      state.updateSuccess = false;
      state.deleteSuccess = false;
      state.uploadSuccess = false;
      state.dashboardThemeUploadSuccess = false;
      state.assetUploadSuccess = false;
      state.appAssetUploadSuccess = false; // 👈 Add
    },
    clearUploadFlags: (state) => {
      state.uploadSuccess = false;
      state.uploadError = null;
    },
    clearDashboardThemeUploadFlags: (state) => {
      state.dashboardThemeUploadSuccess = false;
      state.dashboardThemeUploadError = null;
    },
    clearAppAssetUploadFlags: (state) => { // 👈 New reducer
      state.appAssetUploadSuccess = false;
      state.appAssetUploadError = null;
    },
    // Set selected business
    setSelectedBusiness: (state, action: PayloadAction<Business | null>) => {
      state.selectedBusiness = action.payload;
    },
    // Set current business (for details page)
    setCurrentBusiness: (state, action: PayloadAction<Business | null>) => {
      state.currentBusiness = action.payload;
    },
    // Clear current business
    clearCurrentBusiness: (state) => {
      state.currentBusiness = null;
    },
    // Reset state
    resetBusinessState: () => initialState,
    // Set page
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    // Set limit
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    resetAssetUploadState: (state) => {
      state.assetUploading = false;
      state.assetUploadSuccess = false;
      state.assetUploadError = null;
    },
    resetAppAssetUploadState: (state) => { // 👈 New reducer
      state.appAssetUploading = false;
      state.appAssetUploadSuccess = false;
      state.appAssetUploadError = null;
    },
    // Update business theme info from dashboard theme upload
    updateBusinessThemeInfo: (state, action: PayloadAction<{
      businessId: string;
      themeVersion: number;
      themeDocId: string;
      logoUrl?: string | null;
    }>) => {
      const { businessId, themeVersion, themeDocId, logoUrl } = action.payload;
      
      // Update in businesses list
      const businessIndex = state.businesses.findIndex(b => b.id === businessId);
      if (businessIndex !== -1) {
        state.businesses[businessIndex].theme_uploaded = true;
        state.businesses[businessIndex].theme_version = themeVersion;
        state.businesses[businessIndex].theme_doc_id = themeDocId;
        state.businesses[businessIndex].theme_uploaded_at = new Date().toISOString();
        if (logoUrl) {
          state.businesses[businessIndex].logo_uploaded = true;
          state.businesses[businessIndex].logo_url = logoUrl;
          state.businesses[businessIndex].logo_uploaded_at = new Date().toISOString();
        }
      }
      
      // Update current business if it matches
      if (state.currentBusiness?.id === businessId) {
        state.currentBusiness.theme_uploaded = true;
        state.currentBusiness.theme_version = themeVersion;
        state.currentBusiness.theme_doc_id = themeDocId;
        state.currentBusiness.theme_uploaded_at = new Date().toISOString();
        if (logoUrl) {
          state.currentBusiness.logo_uploaded = true;
          state.currentBusiness.logo_url = logoUrl;
          state.currentBusiness.logo_uploaded_at = new Date().toISOString();
        }
      }
      
      // Update selected business if it matches
      if (state.selectedBusiness?.id === businessId) {
        state.selectedBusiness.theme_uploaded = true;
        state.selectedBusiness.theme_version = themeVersion;
        state.selectedBusiness.theme_doc_id = themeDocId;
        state.selectedBusiness.theme_uploaded_at = new Date().toISOString();
        if (logoUrl) {
          state.selectedBusiness.logo_uploaded = true;
          state.selectedBusiness.logo_url = logoUrl;
          state.selectedBusiness.logo_uploaded_at = new Date().toISOString();
        }
      }
      
      state.dashboardThemeVersion = themeVersion;
    },
  },
  extraReducers: (builder) => {
    /** -------- FETCH SELECTED BUSINESS DASHBOARD THEME -------- **/
    builder
    .addCase(getSelectedBusinessDashboardTheme.pending, (state) => {
      state.selectedBusinessThemeLoading = true;
      state.selectedBusinessThemeError = null;
      state.selectedBusinessThemeSuccess = false;
      console.log(`⏳ Fetching dashboard theme for business...`, state.selectedBusiness?.id);
    })
    .addCase(getSelectedBusinessDashboardTheme.fulfilled, (state, action) => {
      state.selectedBusinessThemeLoading = false;
      state.selectedBusinessThemeSuccess = true;
      state.selectedBusinessThemeError = null;

      const themeData = action.payload.data;
      if(themeData && themeData.theme) {
        state.selectedBusinessTheme = themeData.theme || null;
      }
    })
    .addCase(getSelectedBusinessDashboardTheme.rejected, (state, action) => {
      state.selectedBusinessThemeLoading = false;
      state.selectedBusinessThemeSuccess = false;
      state.selectedBusinessThemeError = action.payload as string || 'Failed to fetch dashboard theme';
      
      if (action.payload === "THEME_NOT_FOUND") {
        console.log(`⚠️ Theme not found, clearing business theme`);
        state.selectedBusinessTheme = null;
      }
      
      console.error(`❌ Failed to fetch dashboard theme:`, action.payload);
    })

    /** -------- FETCH BUSINESSES -------- **/
    builder
      .addCase(fetchBusinesses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinesses.fulfilled, (state, action) => {
        state.loading = false;
        state.businesses = action.payload.data;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
        state.total = action.payload.total;
        state.lastDocId = action.payload.lastDocId;
      })
      .addCase(fetchBusinesses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch businesses";
      });

    /** -------- FETCH BUSINESS BY ID -------- **/
    builder
      .addCase(fetchBusinessById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinessById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentBusiness = action.payload;
      })
      .addCase(fetchBusinessById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch business";
        state.currentBusiness = null;
      });

    /** -------- CREATE BUSINESS -------- **/
    builder
      .addCase(createBusiness.pending, (state) => {
        state.creating = true;
        state.createError = null;
        state.createSuccess = false;
      })
      .addCase(createBusiness.fulfilled, (state, action) => {
        state.creating = false;
        state.createSuccess = true;
        state.businesses.unshift(action.payload);
        state.currentBusiness = action.payload;
        state.total += 1;
      })
      .addCase(createBusiness.rejected, (state, action) => {
        state.creating = false;
        state.createError = action.payload || "Failed to create business";
        state.createSuccess = false;
      });

    /** -------- UPDATE BUSINESS -------- **/
    builder
      .addCase(updateBusiness.pending, (state) => {
        state.updating = true;
        state.updateError = null;
        state.updateSuccess = false;
      })
      .addCase(updateBusiness.fulfilled, (state, action) => {
        state.updating = false;
        state.updateSuccess = true;
        
        const index = state.businesses.findIndex(
          (b) => b.id === action.payload.id
        );
        if (index !== -1) {
          state.businesses[index] = action.payload;
        }
        
        if (state.selectedBusiness?.id === action.payload.id) {
          state.selectedBusiness = action.payload;
        }
        
        if (state.currentBusiness?.id === action.payload.id) {
          state.currentBusiness = action.payload;
        }
      })
      .addCase(updateBusiness.rejected, (state, action) => {
        state.updating = false;
        state.updateError = action.payload || "Failed to update business";
        state.updateSuccess = false;
      });

    /** -------- DELETE BUSINESS -------- **/
    builder
      .addCase(deleteBusiness.pending, (state) => {
        state.deleting = true;
        state.deleteError = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteBusiness.fulfilled, (state, action) => {
        state.deleting = false;
        state.deleteSuccess = true;
        state.businesses = state.businesses.filter(
          (b) => b.id !== action.payload
        );
        state.total -= 1;
        
        if (state.selectedBusiness?.id === action.payload) {
          state.selectedBusiness = null;
        }
        if (state.currentBusiness?.id === action.payload) {
          state.currentBusiness = null;
        }
      })
      .addCase(deleteBusiness.rejected, (state, action) => {
        state.deleting = false;
        state.deleteError = action.payload || "Failed to delete business";
        state.deleteSuccess = false;
      });

    /** -------- UPLOAD BUSINESS THEME (Legacy) -------- **/
    builder
      .addCase(uploadBusinessTheme.pending, (state) => {
        state.uploading = true;
        state.uploadError = null;
        state.uploadSuccess = false;
      })
      .addCase(uploadBusinessTheme.fulfilled, (state, action) => {
        state.uploading = false;
        state.uploadSuccess = true;
        
        const businessCode = action.payload.businessData?.code;
        
        const businessIndex = state.businesses.findIndex(b => b.code === businessCode);
        if (businessIndex !== -1) {
          state.businesses[businessIndex].theme_uploaded = true;
          state.businesses[businessIndex].theme_uploaded_at = action.payload.businessData?.theme_uploaded_at;
        }
        
        if (state.selectedBusiness && state.selectedBusiness?.code === businessCode) {
          state.selectedBusiness.theme_uploaded = true;
          state.selectedBusiness.theme_uploaded_at = action.payload.businessData?.theme_uploaded_at;
        }
        
        if (state.currentBusiness && state.currentBusiness?.code === businessCode) {
          state.currentBusiness.theme_uploaded = true;
          state.currentBusiness.theme_uploaded_at = action.payload.businessData?.theme_uploaded_at;
        }
      })
      .addCase(uploadBusinessTheme.rejected, (state, action) => {
        state.uploading = false;
        state.uploadError = action.payload || "Failed to upload theme";
        state.uploadSuccess = false;
      })

    /** -------- UPLOAD DASHBOARD THEME -------- **/
    builder
      .addCase(uploadDashboardTheme.pending, (state) => {
        state.dashboardThemeUploading = true;
        state.dashboardThemeUploadError = null;
        state.dashboardThemeUploadSuccess = false;
      })
      .addCase(uploadDashboardTheme.fulfilled, (state, action) => {
        state.dashboardThemeUploading = false;
        state.dashboardThemeUploadSuccess = true;
        
        const { businessId, themeVersion, themeDocId, logoUrl, businessName } = action.payload.data;
        
        state.dashboardThemeVersion = themeVersion;
        
        const businessIndex = state.businesses.findIndex(b => b.id === businessId);
        if (businessIndex !== -1) {
          state.businesses[businessIndex].theme_uploaded = true;
          state.businesses[businessIndex].theme_version = themeVersion;
          state.businesses[businessIndex].theme_doc_id = themeDocId;
          state.businesses[businessIndex].theme_uploaded_at = new Date().toISOString();
          
          if (logoUrl) {
            state.businesses[businessIndex].logo_uploaded = true;
            state.businesses[businessIndex].logo_url = logoUrl;
            state.businesses[businessIndex].logo_uploaded_at = new Date().toISOString();
          }
        }
        
        if (state.currentBusiness?.id === businessId) {
          state.currentBusiness.theme_uploaded = true;
          state.currentBusiness.theme_version = themeVersion;
          state.currentBusiness.theme_doc_id = themeDocId;
          state.currentBusiness.theme_uploaded_at = new Date().toISOString();
          
          if (logoUrl) {
            state.currentBusiness.logo_uploaded = true;
            state.currentBusiness.logo_url = logoUrl;
            state.currentBusiness.logo_uploaded_at = new Date().toISOString();
          }
        }
        
        if (state.selectedBusiness?.id === businessId) {
          state.selectedBusiness.theme_uploaded = true;
          state.selectedBusiness.theme_version = themeVersion;
          state.selectedBusiness.theme_doc_id = themeDocId;
          state.selectedBusiness.theme_uploaded_at = new Date().toISOString();
          
          if (logoUrl) {
            state.selectedBusiness.logo_uploaded = true;
            state.selectedBusiness.logo_url = logoUrl;
            state.selectedBusiness.logo_uploaded_at = new Date().toISOString();
          }
        }
        
        console.log(`✅ Dashboard theme v${themeVersion} uploaded for business ${businessId}`);
      })
      .addCase(uploadDashboardTheme.rejected, (state, action) => {
        state.dashboardThemeUploading = false;
        state.dashboardThemeUploadError = action.payload || "Failed to upload dashboard theme";
        state.dashboardThemeUploadSuccess = false;
      })

    /** -------- UPLOAD BUSINESS ASSET (Admin Dashboard Assets) -------- **/
    builder
      .addCase(uploadBusinessAsset.pending, (state) => {
        state.assetUploading = true;
        state.assetUploadError = null;
        state.assetUploadSuccess = false;
      })
      .addCase(uploadBusinessAsset.fulfilled, (state, action) => {
        state.assetUploading = false;
        state.assetUploadSuccess = true;
        
        const { fileType, publicUrl, timestamp } = action.payload;
        const fileName = action.meta.arg.fileName;
        
        if (state.currentBusiness) {
          switch (fileType) {
            case 'logo':
              state.currentBusiness.logo_uploaded = true;
              state.currentBusiness.logo_url = publicUrl;
              state.currentBusiness.logo_uploaded_at = timestamp;
              state.currentBusiness.logo_filename = fileName;
              break;
              
            case 'background':
              state.currentBusiness.background_uploaded = true;
              state.currentBusiness.background_url = publicUrl;
              state.currentBusiness.background_uploaded_at = timestamp;
              state.currentBusiness.background_filename = fileName;
              break;
              
            case 'theme':
              state.currentBusiness.theme_uploaded = true;
              state.currentBusiness.theme_url = publicUrl;
              state.currentBusiness.theme_uploaded_at = timestamp;
              state.currentBusiness.theme_filename = fileName;
              break;
          }
        }
        
        if (state.currentBusiness?.id) {
          const index = state.businesses.findIndex(b => b.id === state.currentBusiness?.id);
          if (index !== -1) {
            switch (fileType) {
              case 'logo':
                state.businesses[index].logo_uploaded = true;
                state.businesses[index].logo_url = publicUrl;
                state.businesses[index].logo_uploaded_at = timestamp;
                state.businesses[index].logo_filename = fileName;
                break;
              case 'background':
                state.businesses[index].background_uploaded = true;
                state.businesses[index].background_url = publicUrl;
                state.businesses[index].background_uploaded_at = timestamp;
                state.businesses[index].background_filename = fileName;
                break;
              case 'theme':
                state.businesses[index].theme_uploaded = true;
                state.businesses[index].theme_url = publicUrl;
                state.businesses[index].theme_uploaded_at = timestamp;
                state.businesses[index].theme_filename = fileName;
                break;
            }
          }
        }
      })
      .addCase(uploadBusinessAsset.rejected, (state, action) => {
        state.assetUploading = false;
        state.assetUploadSuccess = false;
        state.assetUploadError = action.payload as string;
      })

    /** -------- UPLOAD APP BUSINESS ASSET (App Assets: logos, backgrounds, onboarding) -------- **/
    builder
      .addCase(uploadAppBusinessAsset.pending, (state) => {
        state.appAssetUploading = true;
        state.appAssetUploadError = null;
        state.appAssetUploadSuccess = false;
      })
      .addCase(uploadAppBusinessAsset.fulfilled, (state, action) => {
        state.appAssetUploading = false;
        state.appAssetUploadSuccess = true;
        
        const { fileType, publicUrl, timestamp } = action.payload;
        const fileName = action.meta.arg.fileName;
        
        if (state.currentBusiness) {
          switch (fileType) {
            case 'logos':
              // Handle light/dark logos based on filename pattern
              if (fileName.includes('light')) {
                state.currentBusiness.app_logo_light_uploaded = true;
                state.currentBusiness.app_logo_light_url = publicUrl;
                state.currentBusiness.app_logo_light_uploaded_at = timestamp;
                state.currentBusiness.app_logo_light_filename = fileName;
              } else if (fileName.includes('dark')) {
                state.currentBusiness.app_logo_dark_uploaded = true;
                state.currentBusiness.app_logo_dark_url = publicUrl;
                state.currentBusiness.app_logo_dark_uploaded_at = timestamp;
                state.currentBusiness.app_logo_dark_filename = fileName;
              }
              break;
              
            case 'backgrounds':
              // Handle light/dark backgrounds based on filename pattern
              if (fileName.includes('light')) {
                state.currentBusiness.app_background_light_uploaded = true;
                state.currentBusiness.app_background_light_url = publicUrl;
                state.currentBusiness.app_background_light_uploaded_at = timestamp;
                state.currentBusiness.app_background_light_filename = fileName;
              } else if (fileName.includes('dark')) {
                state.currentBusiness.app_background_dark_uploaded = true;
                state.currentBusiness.app_background_dark_url = publicUrl;
                state.currentBusiness.app_background_dark_uploaded_at = timestamp;
                state.currentBusiness.app_background_dark_filename = fileName;
              }
              break;
              
            case 'onboarding':
              // Initialize onboarding_images array if it doesn't exist
              if (!state.currentBusiness.onboarding_images) {
                state.currentBusiness.onboarding_images = [];
              }
              
              // Extract ID from filename (e.g., onboarding-1.jpg -> 1)
              const idMatch = fileName.match(/onboarding-(\d+)/);
              const id = idMatch ? parseInt(idMatch[1]) : (state.currentBusiness.onboarding_images.length + 1);
              
              // Check if this onboarding image already exists
              const existingIndex = state.currentBusiness.onboarding_images.findIndex(img => img.id === id);
              
              const onboardingImage = {
                id,
                url: publicUrl,
                filename: fileName,
                uploaded_at: timestamp,
              };
              
              if (existingIndex !== -1) {
                // Update existing
                state.currentBusiness.onboarding_images[existingIndex] = onboardingImage;
              } else {
                // Add new
                state.currentBusiness.onboarding_images.push(onboardingImage);
              }
              
              // Update onboarding count
              state.currentBusiness.onboarding_count = state.currentBusiness.onboarding_images.length;
              break;
          }
        }
        
        // Also update in businesses list if currentBusiness exists
        if (state.currentBusiness?.id) {
          const index = state.businesses.findIndex(b => b.id === state.currentBusiness?.id);
          if (index !== -1) {
            // Update the business in the list to match currentBusiness
            state.businesses[index] = { ...state.businesses[index], ...state.currentBusiness };
          }
        }
      })
      .addCase(uploadAppBusinessAsset.rejected, (state, action) => {
        state.appAssetUploading = false;
        state.appAssetUploadSuccess = false;
        state.appAssetUploadError = action.payload as string;
      });
  },
});

/** ------------------- EXPORTS ------------------- **/

export const {
  clearErrors,
  clearSuccessFlags,
  setSelectedBusiness,
  setCurrentBusiness,
  clearCurrentBusiness,
  resetBusinessState,
  setPage,
  setLimit,
  clearUploadFlags,
  clearDashboardThemeUploadFlags,
  clearAppAssetUploadFlags, // 👈 Export new reducer
  updateBusinessThemeInfo,
  resetAssetUploadState,
  resetAppAssetUploadState, // 👈 Export new reducer
} = businessSlice.actions;

// ============== SELECTORS FOR APP ASSETS ==============
export const selectAppLogoLight = (state: { business_slice: BusinessState }) => 
  state.business_slice.currentBusiness?.app_logo_light_url || null;

export const selectAppLogoDark = (state: { business_slice: BusinessState }) => 
  state.business_slice.currentBusiness?.app_logo_dark_url || null;

export const selectAppBackgroundLight = (state: { business_slice: BusinessState }) => 
  state.business_slice.currentBusiness?.app_background_light_url || null;

export const selectAppBackgroundDark = (state: { business_slice: BusinessState }) => 
  state.business_slice.currentBusiness?.app_background_dark_url || null;

export const selectOnboardingImages = (state: { business_slice: BusinessState }) => 
  state.business_slice.currentBusiness?.onboarding_images || [];

export const selectAppAssetUploading = (state: { business_slice: BusinessState }) => 
  state.business_slice.appAssetUploading;

export const selectAppAssetUploadSuccess = (state: { business_slice: BusinessState }) => 
  state.business_slice.appAssetUploadSuccess;

export const selectAppAssetUploadError = (state: { business_slice: BusinessState }) => 
  state.business_slice.appAssetUploadError;

export default businessSlice.reducer;